export default __webpack_public_path__ + "static/media/01-business_thumb.3ec72ea7.png";